import { Vector3, VertexBuffer } from '@babylonjs/core/pure';
import type { Mesh } from '@babylonjs/core/pure';

/** Bake meter-based planar UVs before merging; all PBR maps share these coordinates. */
export function worldScaleUVs(mesh: Mesh, metersPerTile = 2): void {
  const positions = mesh.getVerticesData(VertexBuffer.PositionKind);
  const normals = mesh.getVerticesData(VertexBuffer.NormalKind);
  if (!positions || !normals) return;
  const matrix = mesh.computeWorldMatrix(true);
  const uv: number[] = [];
  for (let i = 0; i < positions.length; i += 3) {
    const p = Vector3.TransformCoordinates(Vector3.FromArray(positions, i), matrix);
    const n = Vector3.TransformNormal(Vector3.FromArray(normals, i), matrix);
    const x = Math.abs(n.x), y = Math.abs(n.y), z = Math.abs(n.z);
    const [u, v] = x >= y && x >= z ? [p.z, p.y] : y >= z ? [p.x, p.z] : [p.x, p.y];
    uv.push(u / metersPerTile, v / metersPerTile);
  }
  mesh.setVerticesData(VertexBuffer.UVKind, uv, false);
}
